<template>
    <div class="max-w-4xl mx-auto bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
        <h1 class="text-2xl font-bold text-gray-900 mb-6">{{ $translate('Account Preferences') }}</h1>

        <form @submit.prevent="handleSubmit" class="space-y-6">
            <!-- Public Profile Toggle -->
            <div>
                <div class="flex items-center justify-between">
                    <label for="optInPublic" class="block text-sm font-medium text-gray-700">
                        {{ $translate('Promote Publicly') }}
                    </label>
                    <input type="checkbox" id="optInPublic" v-model="form.optInPublic" class="form-toggle" />
                </div>
                <p class="text-sm text-gray-500">
                    {{ $translate('Allow your profile to be visible publicly without anonymization.') }}
                </p>
            </div>
            <div>
                <!-- Newsletter Subscription Toggle -->
                <div class="flex items-center justify-between">
                    <label for="optInNewsletter" class="block text-sm font-medium text-gray-700">
                        {{ $translate('Subscribe to Newsletter') }}
                    </label>
                    <input type="checkbox" id="optInNewsletter" v-model="form.optInNewsletter" class="form-toggle" />
                </div>
                <p class="text-sm text-gray-500">
                    {{ $translate('Receive information about upcoming events and marketing emails.') }}
                </p>
            </div>
            <!-- Submit Button -->
            <div>
                <button type="submit"
                    class="w-full bg-blue-600 text-white py-3 px-4 rounded-md font-semibold hover:bg-blue-700 transition">
                    {{ $translate('Save Changes') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { translate } from '@/utils/translate';
import { notify } from 'notiwind';
import { cookie } from '@/utils/cookie';

export default {
    data() {
        return {
            form: {
                optInPublic: false, // Toggle for public profile
                optInNewsletter: false, // Toggle for newsletter subscription
            },
        };
    },
    mounted() {
        this.fetchAccountInfo();
    },
    methods: {
        async fetchAccountInfo() {
            try {
                const response = await fetch(`${window.vueAppConfig.endpoint}/api/v2/session/account/info`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({ session_id: cookie(), brand_id: window.vueAppConfig.info.id }),
                });

                const data = await response.json();
                if (data.status) {
                    this.prefillForm(data.data);
                } else {
                    notify({
                        type: 'error',
                        group: 'error',
                        title: translate('Error'),
                        text: data.message,
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    group: 'error',
                    title: translate('Error'),
                    text: error.message,
                });
            }
        },
        prefillForm(data) {
            // Populate the form with fetched data
            this.form.optInPublic = data.optInPublic || false;
            this.form.optInNewsletter = data.optInNewsletter || false;
        },
        async handleSubmit() {
            // Prepare form data for the API
            const formData = new FormData();
            formData.append('optInPublic', this.form.optInPublic);
            formData.append('optInNewsletter', this.form.optInNewsletter);
            formData.append('session_id', cookie());
            formData.append('brand_id', window.vueAppConfig.info.id);

            try {
                const response = await fetch(`${window.vueAppConfig.endpoint}/api/v2/session/account/update`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                    },
                    body: formData,
                });

                const data = await response.json();
                if (data.status) {
                    notify({
                        type: 'success',
                        group: 'info',
                        title: translate('Success'),
                        text: data.message,
                    });
                } else {
                    notify({
                        type: 'error',
                        group: 'error',
                        title: translate('Error'),
                        text: data.message,
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    group: 'error',
                    title: translate('Error'),
                    text: error.message,
                });
            }
        },
    },
};
</script>